export default __webpack_public_path__ + "static/media/payment-step-active.25b78ecc.svg";